<template>
  <v-container fluid class="pa-0" style="min-height:340px;">
    <v-layout row wrap class="mb-2" v-if="showDetails">
      <v-flex xs4 offset-xs2 class="text-xs-center">
        <p :class="segment === 'paciente' ? active : inactive" @click="segment = 'paciente'">
          PACIENTE
        </p>
      </v-flex>
      <v-flex xs4 class="text-xs-center">
        <p :class="segment === 'presupuesto' ? active : inactive" @click="segment = 'presupuesto'">
          PRESUPUESTO
        </p>
      </v-flex>
    </v-layout>
    <v-layout v-if="segment === 'presupuesto'">
      <v-flex xs12>
            <p class="mb-0 text-xs-center">
              <small>Expira el: 
                <strong class="primary--text">
                  {{$moment(quotation.expires_at).format('D MMM YYYY HH:mm')}}
                </strong>
              </small><br />
            </p>
            <table style="width:100%">
              <tr>
                <th class="pa-1 text-xs-left">Ctd.</th>
                <th class="pa-1 text-xs-left">Descripción</th>
                <th class="pa-1 text-xs-center">%</th>
                <th class="pa-1 text-xs-left">Valor Un.</th>
              </tr>
              <tr v-for="item in mapedServices" :key="item.id">
                <td class="pa-1 text-xs-center">{{ item.qty }}</td>
                <td class="pa-1">{{ item.description }}</td>
                <td class="pa-1 text-xs-center">{{ item.discount }}</td>
                <td class="pa-1 text-xs-right">
                  {{ item.price.toLocaleString('es') }}
                </td>
              </tr>
            </table>
            <table style="width:50%;margin-left:50%;">
              <tr>
                <td class="pa-1 text-xs-right font-weight-bold">Neto</td>
                <td class="pa-1 text-xs-right">
                  {{ calculatedServices.neto.toLocaleString('es') }}
                </td>
              </tr>
              <tr>
                <td class="pa-1 text-xs-right font-weight-bold">Impuesto</td>
                <td class="pa-1 text-xs-right">
                  {{ calculatedServices.taxes.toLocaleString('es') }}
                </td>
              </tr>
              <tr>
                <td class="pa-1  text-xs-right font-weight-bold">Total</td>
                <td class="pa-1 text-xs-right">
                  {{ calculatedServices.total.toLocaleString('es') }}
                </td>
              </tr>
            </table>
            <div class="grey lighten-2 pa-2 mt-1" v-if="!!quotation.comments">
              <p class="mb-0">
                <small class="primary--text">Comentarios</small><br />
              </p>
              <p
                class="mb-1"
                v-html="quotation.comments"
              ></p>
            </div>
            <v-btn outline color="primary" class="mt-4" block small v-if="quotation.preview" @click="viewPDF = true">Ver Presupuesto en PDF</v-btn>
          </v-flex>
    </v-layout>
    <v-layout row wrap v-else-if="segment === 'paciente'">
      <v-flex xs12>
        <div class="grey lighten-3 pa-2 mb-2">
          <p>
            <small class="primary--text">Presupuesto creado el</small
            ><br />
            {{ $moment(quotation.created_at).format('D MMM YYYY HH:mm') }}
          </p>
        </div>
        <div class="grey lighten-3 pa-2 mb-2" v-if="showStatus">
          <p>
            <small class="primary--text">Estado</small><br />
            {{
              quotation.quoted
                ? 'Presupuesto Completado'
                : 'Presupuesto Solicitado'
            }}
          </p>
        </div>
        <div class="grey lighten-3 pa-2 mb-2">
          <p>
            <small class="primary--text">Solicitado por</small><br />
            {{ quotation.client.first_name || '---' }}
            {{ quotation.client.last_name || '---' }}
            {{ quotation.client.mother_last_name || '---' }}
          </p>
          <p>
            <small class="primary--text">Rut</small><br />
            {{ quotation.client.dni | rut }}
          </p>
          <p>
            <small class="primary--text">Email</small><br />
            {{ quotation.client.email || '---' }}
          </p>
          <p>
            <small class="primary--text">Teléfonos</small><br />
            {{ quotation.client.phone1 | phone_format }}
          </p>
        </div>
        <div class="grey lighten-3 pa-2 mb-2" v-if="!showDetails">
            <p class="mb-0">
              <small class="primary--text">Solicitud por</small><br />
              {{ service.serviceName }} |
              {{ quotation.service_items[0].description }}
            </p>
        </div>
      </v-flex>
    </v-layout>
    <v-dialog v-model="viewPDF" max-width="800px">
      <v-card>
        <v-card-text>
          <iframe :src="quotation.preview" style="border:none;width:100%;min-height:400px;"></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
export default {
  props: {
    quotation: {
      type: Object
    },
    services: {
      type: Array,
      required: true
    },
    text: {
      type: String,
      default: 'Solicitado el'
    },
    showDetails: {
      type: Boolean,
      default: false
    },
    showStatus: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      service: {},
      segment: 'paciente',
      base: 'ma-0 pa-2 text-xs-center',
      active: 'primary white--text font-weight-bold',
      inactive: 'grey lighten-3 grey--text pointer font-weight-bold',
      viewPDF: false
    }
  },
  watch: {
    quotation: function(val) {
      this.service = this.findService(this.quotation.service_items[0].id)
    },
    showDetails: function(val) {
      if (!val)
        this.segment = 'paciente'
    }
  },
  mounted() {
    this.service = this.findService(this.quotation.service_items[0].id)
  },
  computed: {
    mapedServices() {
      if (!this.showDetails) return []
      return this.quotation.service_items.map(item => {
        const service = this.findService(item.pivot.service_item_id)
        const el = {
          id: item.pivot.service_item_id,
          qty: item.pivot.qty,
          description: service ? service.fullName : 'Unespecified',
          discount: parseInt(item.pivot.discount),
          price: item.pivot.price,
          total: item.pivot.total,
          discounted: item.pivot.price,
          taxFree: !!item.pivot.tax_free,
          final: item.pivot.price,
          tax: 0
        }
        if (el.discount > 0)
          el.discounted = el.price - el.price * (el.discount / 100)
        if (!el.taxFree) el.tax = el.discounted * 0.19
        el.final = (el.discounted + el.tax) * el.qty
        return el
      })
    },
    calculatedServices() {
      if (!this.showDetails) return { total: 0, taxes: 0 }
      let total = 0
      let taxes = 0
      let neto = 0
      this.mapedServices.forEach(item => {
        if (!item.taxFree) taxes += item.tax * item.qty
        total += item.final
        neto += (item.qty * item.discounted)

      })
      return { total, taxes, neto }
    }
  },
  methods: {
    findService(id) {
      return this.services.find(el => el.serviceItemId === id)
    }
  }
}
</script>
<style scoped>
p {
  margin-bottom: 5px;
  padding: 0;
}
th {
  background-color: rgb(68, 40, 47);
  color: #fff;
}
td {
  background-color: rgb(214, 214, 214);
}
.pointer {
  cursor: pointer;
}
</style>